<template>
  <div class="ani-float float-icon">
    <div
      class="cart-content py-md-0 py-4"
      data-bs-toggle="modal"
      data-bs-target="#cartModal"
    >
      <div class="cart-icon me-md-0 me-4">
        <div class="cart-item-no font-14 text-white bg-theme-1 text-center">
          {{cart.length}}
        </div>
      </div>
      <div class="d-md-none">
        <span class="font-14 text-uppercase text-theme-1 fw-bold"
          >View Cart</span
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatIcon",
  props: ['cart'],
};
</script>